/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub Forge
 * extension. Must remain stable across product releases — changing it is a
 * breaking change to persisted hub content.
 *
 * Mirrors the Help Center Forge module shape so that Forge UI Kit / Custom UI
 * extensions can be shared between Help Center and Hub editors.
 */
export const HUB_FORGE_EXTENSION_TYPE = 'com.atlassian.hub-forge';

/**
 * Logical key used by `getExtensionManifest` and by the registry in
 * `@atlassian/hub-extension-schemas`. Kept in sync with
 * `HUB_FORGE_EXTENSION_TYPE` minus the reverse-DNS prefix.
 */
export const HUB_FORGE_EXTENSION_KEY = 'hub-forge';

/**
 * Per-slot manifest keys emitted into ADF `extensionKey`. Mirrors the manifest
 * entries in `ui/hub-forge-manifest`.
 */
export const HUB_FORGE_HEADER_EXTENSION_KEY: string = `${HUB_FORGE_EXTENSION_KEY}-header`;
export const HUB_FORGE_FOOTER_EXTENSION_KEY: string = `${HUB_FORGE_EXTENSION_KEY}-footer`;

/**
 * Default semver carried in ADF `parameters.version`. Bump when the Zod
 * schema changes shape in a non-backwards-compatible way.
 */
export const HUB_FORGE_EXTENSION_VERSION_1 = '1.0.0';

/**
 * Identifies which slot of the hub a Forge extension was inserted into.
 * Drives the insert-menu manifest (one entry per slot) and the labelled chip
 * shown above the extension node in the editor.
 */
export const ForgeElementType = {
	HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
	FOOTER_PANELS: 'footerPanels',
} as const;

/**
 * Page context the extension renders inside.
 */
export const ForgePageContext = {
	HELP_HUB: 'HELP_HUB',
} as const;

export const HUB_FORGE_EXTENSION_ANALYTIC_SOURCE = 'hubForgeExtension';
export const HUB_FORGE_EXTENSION_CONFIG_ANALYTIC_SOURCE = 'hubForgeExtensionConfig';

/**
 * Default URL surfaced as "Learn more" in the config-panel module card when
 * the consumer does not supply a more specific link. Points at the Forge
 * Jira Service Management module manifest reference.
 */
export const HUB_FORGE_LEARN_MORE_URL =
	'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';
